import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import { motion } from "motion/react";

function TermsOfServicePage() {
  return (
    <div className="mx-auto w-full max-w-300 px-6 pt-4 pb-8 md:px-8 md:pt-6 md:pb-10 lg:px-12 lg:pt-8 lg:pb-12">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0, transition: { delay: 0.2 } }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 2,
          }}
        >
          <img
            src="/assets/images/logo/logo_loanapp.png"
            alt="ASSETS ID"
            width={165}
            height={70}
          />
        </Box>

        <Typography
          variant="h1"
          className="mb-10 text-center text-4xl font-semibold leading-[1.25] tracking-tight md:text-6xl md:leading-none"
        >
          Terms of Service
        </Typography>

        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          These terms and conditions govern your use of this web site. By
          accessing this web site, you are acknowledging and accepting these
          terms of use. These terms of use are subject to change by AssetsID
          (hereinafter "Company") at any time and at our discretion without
          notice. Your use of this web site after any changes are implemented
          constitutes your acceptance of the changes. As a result, we encourage
          you to consult the terms and conditions each time you use this web
          site.
        </Typography>

        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          INTELLECTUAL PROPERTY:
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          You acknowledge and agree that all content and materials available on
          this site are protected by copyrights, trademarks, service marks,
          patents, trade secrets, or other proprietary rights and laws. Except
          as expressly authorized by AssetsID, you agree not to sell, license,
          rent, modify, distribute, copy, reproduce, transmit, publicly display,
          publicly perform, publish, adapt, edit, or create derivative works
          from such materials or content.
          <br /> <br />
          As noted above, reproduction, copying, or redistribution for
          commercial purposes of any materials or design elements on this site
          is strictly prohibited without the express written permission of
          AssetsID. For information on requesting such permission, please
          contact us via our email.
        </Typography>
        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          THIRD PARTY REFERENCES / HYPERLINKS / ADS:
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          The Site may contain links to third-party websites and services,
          and/or display advertisements for third-parties. Such Third-Party
          Links & Ads are not under the control of Company, and Company is not
          responsible for any Third-Party Links & Ads. Company provides access
          to these Third-Party Links & Ads only as a convenience to you, and
          does not review, approve, monitor, endorse, warrant, or make any
          representations with respect to Third-Party Links & Ads.
          <br /> <br />
          You use all Third-Party Links & Ads at your own risk, and should apply
          a suitable level of caution and discretion in doing so. When you click
          on any of the Third-Party Links & Ads, the applicable third party's
          terms and policies apply, including the third party's privacy and data
          gathering practices.
        </Typography>
        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          COOKIES AND WEB BEACONS:
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          Like any other website, AssetsID uses 'cookies'. These cookies are
          used to store information including visitors' preferences, and the
          pages on the website that the visitor accessed or visited. The
          information is used to optimize the users' experience by customizing
          our web page content based on visitors' browser type and/or other
          information.
        </Typography>
        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          CONTACTING US:
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          If you need to contact us, you can email us at{" "}
          <a
            href="mailto:support@assetsid.com"
            rel="noopener noreferrer"
          >
            support@assetsid.com
          </a>
        </Typography>
        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          DISCLAIMER OF WARRANTIES:
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          ALL MATERIALS, INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED
          IN OR AVAILABLE THROUGH THIS SITE (THE "CONTENT") ARE PROVIDED "AS IS"
          AND "AS AVAILABLE" FOR YOUR USE. THE CONTENT IS PROVIDED WITHOUT
          WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT
          LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
          PARTICULAR PURPOSE, OR NONINFRINGEMENT. COMPANY AND ITS AGENTS DO NOT
          WARRANT THAT THE CONTENT IS ACCURATE, RELIABLE OR CORRECT; THAT THIS
          SITE WILL BE AVAILABLE AT ANY PARTICULAR TIME OR LOCATION; THAT ANY
          DEFECTS OR ERRORS WILL BE CORRECTED; OR THAT THE CONTENT IS FREE OF
          VIRUSES OR OTHER HARMFUL COMPONENTS. YOUR USE OF THIS SITE IS SOLELY
          AT YOUR RISK. BECAUSE SOME JURISDICTIONS DO NOT PERMIT THE EXCLUSION
          OF CERTAIN WARRANTIES, THESE EXCLUSIONS MAY NOT APPLY TO YOU. SOME OF
          THE CLAIMS MADE ON THE SITE ARE SIMPLY OPINIONS OF THE AUTHOR.
        </Typography>
        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          LIMITATION OF LIABILITY:
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          UNDER NO CIRCUMSTANCES SHALL ASSETSID OR ITS AGENTS BE LIABLE FOR ANY
          DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL
          DAMAGES THAT RESULT FROM THE USE OF, OR INABILITY TO USE, THIS SITE.
          THIS LIMITATION APPLIES WHETHER THE ALLEGED LIABILITY IS BASED ON
          CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY, OR ANY OTHER BASIS, EVEN
          IF ASSETSID HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          BECAUSE SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF
          INCIDENTAL OR CONSEQUENTIAL DAMAGES, ASSETSID'S LIABILITY IN SUCH
          JURISDICTIONS SHALL BE LIMITED TO THE EXTENT PERMITTED BY LAW.
        </Typography>
        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          INDEMNIFICATION:
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          Upon a request by assetsid, you agree to defend, indemnify, and hold
          assetsid and its other affiliated companies harmless, and their
          employees, contractors, officers, and directors from all liabilities,
          claims, and expenses, including attorney's fees, that arise from your
          misuse of this site.
        </Typography>
        <Typography
          variant="h2"
          className="mt-10 mb-4 text-3xl font-semibold leading-[1.25] tracking-tight md:leading-none"
        >
          SEVERABILITY AND INTEGRATION:
        </Typography>
        <Typography
          variant="h5"
          color="text.secondary"
          className="mt-2 text-lg font-medium tracking-tight md:text-xl"
        >
          Unless otherwise specified herein, this agreement constitutes the
          entire agreement between you and assetsid with respect to this site
          and supersedes all prior or contemporaneous communications between you
          and assetsid with respect to this site. If any part of these Terms of
          Use is held invalid or unenforceable, that portion shall be construed
          in a manner consistent with applicable law to reflect, as nearly as
          possible, the original intentions of the parties, and the remaining
          portions shall remain in full force and effect.
        </Typography>
      </motion.div>
    </div>
  );
}

export default TermsOfServicePage;
